<div [appEnforcePermission]="authConfig.contactsProfileContactInformationViewAssigned"
  #contactsProfileContactInformationViewAssigned="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.contactsProfileCompanyInformationView"
  #contactsProfileCompanyInformationView="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.contactsInvestigations" #contactsInvestigations="appEnforcePermission"></div>

<span kendoPopoverAnchor [popover]="popoverRef" #anchor="kendoPopoverAnchor" showOn="hover"
  (mouseenter)="handleIconClick()">
  <a *ngIf="contactsInvestigations?.enabled || contactsProfileCompanyInformationView?.enabled || contactsProfileContactInformationViewAssigned?.enabled; else noPermission"
    class="linkmd text-decoration" [routerLink]="['/contacts/', client.id]">{{client |
    fullName}}</a>
  <ng-template #noPermission>{{client | fullName}}</ng-template>
  &nbsp;<i class="fa-solid fa-question-circle cursor-pointer">
  </i>
</span>

<kendo-popover [callout]="true" (hidden)="data = null" #popoverRef>
  <ng-template kendoPopoverBodyTemplate>
    <div class="popover-wrapper">

      <kendo-loader type="infinite-spinner" themeColor="primary" size="medium"
        *ngIf="clientPopoverLoading; else showPopoverData">
      </kendo-loader>

      <ng-template #showPopoverData>
        <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 4, cols: 0 }" [cols]="['repeat(5,minmax(0,1fr))']">

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Company:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              {{ data?.ClientBranch?.Company?.name || '-' }}
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Branch Description:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              {{ data?.ClientBranch?.additionalInformation || '-' }}
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Client:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              {{ (data?.Client | fullName) || '-' }}
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Emails:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              <app-email-phone-view *ngFor="let email of data?.Client?.Emails" [wrapText]="false" [email]="email">
              </app-email-phone-view>
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Phones:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              <app-email-phone-view *ngFor="let phone of data?.Client?.Phones" [wrapText]="false" [phone]="phone">
              </app-email-phone-view>
            </p>
          </kendo-gridlayout-item>

          <kendo-gridlayout-item [colSpan]="2">
            <h6 class="popover-data-title">Addresses:</h6>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item [colSpan]="3">
            <p class="popover-data-value">
              <app-address-view [address]="data?.Client?.BillingAddress">
              </app-address-view>
            </p>
          </kendo-gridlayout-item>

        </kendo-gridlayout>
      </ng-template>
    </div>
  </ng-template>
</kendo-popover>
